(() => {
  if (window.__ZB_SCRIPT_LOADED__) return;
  window.__ZB_SCRIPT_LOADED__ = true;

  // --- Inject CSS dynamically ---
  const style = document.createElement('style');
  style.textContent = `
    .zb-error-message,
    .zb-klaviyo-error {
      color: #ff0000 !important;
      font-family: 'Jost', sans-serif !important;
      font-weight: 400;
      font-size: 13px;
      line-height: 1.4;
      text-align: center;
      width: 100%;
      margin-top: 10px;
      display: block;
      position: relative;
    }

    /* Prevent layout shifts */
    .zb-error-container {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  `;
  document.head.appendChild(style);


  // --- Config ---
  const ZB_CONFIG = {
    apiKey: '1243fcc4a1be4055a22e8b58100122f0',
    targetFormIds: ['NoticeBarNewsletterForm', 'NewsletterForm'],
    // EN and FR input IDs — script tries each until one is found in the DOM
    klaviyoInputIds: [
      '#email_01KP0JHGZKCVSAYN46KX5XE98M', // EN
      '#email_01KRPEQZ4VNVCS80PSNXTBPP51'   // FR
    ],
    // EN and FR generated button classes — script tries each until one is found in the DOM
    klaviyoBtnClasses: [
      'button.go2595921901',  // EN
      'button.go815134948'    // FR
    ],
    // Stable semantic fallback in case Klaviyo regenerates its hash-based classes
    klaviyoBtnClassFallback: 'button.klaviyo-form-button',
    messages: {
      en: {
        invalid: 'Please enter a valid email address.',
        suggest: 'Did you mean',
        checking: 'Validating email...',
        btn: 'Continue'
      },
      fr: {
        invalid: 'Veuillez entrer une adresse courriel valide.',
        suggest: 'Vouliez-vous dire',
        checking: 'Validation du courriel...',
        btn: 'Continuer'
      }
    }
  };

  // --- Helpers ---
  const getLang = () => {
    const htmlLang = document.documentElement.lang?.slice(0, 2);
    if (htmlLang === 'fr') return 'fr';
    return window.location.pathname.startsWith('/fr') ? 'fr' : 'en';
  };

  const findFirst = (selectors) => {
    for (const selector of selectors) {
      const el = document.querySelector(selector);
      if (el) return el;
    }
    return null;
  };

  const showError = (target, message, data = null, className = "zb-error-message") => {
    const form = target.closest("form");
    if (!form) return;

    const existing = form.querySelector(`.${className}`);
    if (existing) existing.remove();

    const error = document.createElement("p");
    error.className = className;

    if (data && data.did_you_mean) {
      const lang = getLang();
      const suggestText = ZB_CONFIG.messages[lang].suggest;
      error.innerHTML = `${ZB_CONFIG.messages[lang].invalid} ${suggestText} <span class="zb-suggestion" style="text-decoration: underline; cursor: pointer; font-weight: bold;">${data.did_you_mean}</span>?`;
    } else {
      error.textContent = message;
    }

    const fieldContainer = target.closest(".form__field") || target.closest('[data-testid="form-row"]');

    if (fieldContainer && fieldContainer.parentNode) {
      fieldContainer.parentNode.insertBefore(error, fieldContainer.nextSibling);
    } else {
      target.insertAdjacentElement("afterend", error);
    }
  };

  const clearError = (target, className = 'zb-error-message') => {
    const existing = target.parentNode.querySelector(`.${className}`);
    if (existing) existing.remove();
  };

  const validateEmailFormat = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const fetchWithTimeout = (url, timeout = 5000) =>
    Promise.race([
      fetch(url),
      new Promise((_, reject) => setTimeout(() => reject(new Error('Timeout')), timeout))
    ]);

  // --- Core validation logic ---
  async function validateWithZeroBounce(email) {
    const response = await fetchWithTimeout(
      `https://api.zerobounce.net/v2/validate?api_key=${ZB_CONFIG.apiKey}&email=${encodeURIComponent(email)}`
    );
    return response.json();
  }

  // --- Shopify Forms ---
  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;
      if (!ZB_CONFIG.targetFormIds.includes(form.id) || form.dataset.zbValidated === 'true') return;

      const emailInput = form.querySelector('input[name="contact[email]"]');
      if (!emailInput) return;

      const email = emailInput.value.trim();
      if (!email) return;

      if (!validateEmailFormat(email)) {
        showError(emailInput, ZB_CONFIG.messages[getLang()].invalid);
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      clearError(emailInput);

      try {
        const data = await validateWithZeroBounce(email);
        if (data.status === 'valid') {
          form.dataset.zbValidated = 'true';
          form.requestSubmit ? form.requestSubmit() : form.submit();
          form.removeAttribute('data-zb-validated');
        } else {
          let errorText = ZB_CONFIG.messages[getLang()].invalid;
          if (data.did_you_mean)
            errorText += ` ${ZB_CONFIG.messages[getLang()].suggest} ${data.did_you_mean}?`;
          showError(emailInput, errorText, data);
          emailInput.focus();
        }
      } catch {
        form.dataset.zbValidated = 'true';
        form.requestSubmit ? form.requestSubmit() : form.submit();
        form.removeAttribute('data-zb-validated');
      }
    },
    true
  );

  // --- Klaviyo Forms ---
  function attachZeroBounceToKlaviyo() {
    const realBtn =
      findFirst(ZB_CONFIG.klaviyoBtnClasses) ||
      document.querySelector(ZB_CONFIG.klaviyoBtnClassFallback);
    const emailInput = findFirst(ZB_CONFIG.klaviyoInputIds);
    if (!realBtn || !emailInput || document.getElementById('zb-proxy-button')) return;

    const proxyBtn = realBtn.cloneNode(true);
    proxyBtn.id = 'zb-proxy-button';
    proxyBtn.type = 'button';
    proxyBtn.setAttribute('aria-disabled', 'false');

    realBtn.style.cssText = 'position:absolute;opacity:0;pointer-events:none;z-index:-1;';
    realBtn.parentNode.insertBefore(proxyBtn, realBtn);

    proxyBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();

      clearError(emailInput, 'zb-klaviyo-error');
      const lang = getLang();
      const email = emailInput.value.trim();
      if (!validateEmailFormat(email)) {
        showError(emailInput, ZB_CONFIG.messages[lang].invalid, 'zb-klaviyo-error');
        return;
      }

      proxyBtn.disabled = true;
      proxyBtn.setAttribute('aria-disabled', 'true');
      proxyBtn.textContent = ZB_CONFIG.messages[lang].checking;

      try {
        const data = await validateWithZeroBounce(email);
        if (data.status === 'valid') {
          proxyBtn.disabled = false;
          proxyBtn.setAttribute('aria-disabled', 'false');
          realBtn.click();
        } else {
          proxyBtn.disabled = false;
          proxyBtn.setAttribute('aria-disabled', 'false');
          proxyBtn.textContent = ZB_CONFIG.messages[lang].btn;
          let errorText = ZB_CONFIG.messages[lang].invalid;
          if (data.did_you_mean)
            errorText += ` ${ZB_CONFIG.messages[lang].suggest} ${data.did_you_mean}?`;
          showError(emailInput, errorText, data, 'zb-klaviyo-error');
        }
      } catch {
        proxyBtn.disabled = false;
        proxyBtn.setAttribute('aria-disabled', 'false');
        realBtn.click();
      }
    });
  }

  document.addEventListener("click", (e) => {
    if (e.target.classList.contains("zb-suggestion")) {
      const suggestedEmail = e.target.textContent;

      const container = e.target.closest("form") || e.target.closest('[role="dialog"]');
      const emailInput = container.querySelector('input[type="email"], input[name="email"], input[name="contact[email]"]');

      if (emailInput) {
        emailInput.value = suggestedEmail;
        emailInput.focus();

        const errorElement = e.target.closest('p');
        if (errorElement) errorElement.remove();
      }
    }
  });

  // --- Observe Klaviyo Popup ---
  const observer = new MutationObserver(() => {
    if (!document.getElementById('zb-proxy-button')) {
      attachZeroBounceToKlaviyo();
    } else {
      observer.disconnect();
    }
  });


  observer.observe(document.body, { childList: true, subtree: true });
})();